module.exports = "/_next/static/images/ManageUserDeletion@2x-8ee7309e6db3288f765d9c03f08e10da.webp";